import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isSuspendFunction153vlp5l2npj9 as isSuspendFunction } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import { Phases_getInstance39l8b4mzhgwzm as Phases_getInstance_0 } from '../statement/HttpResponsePipeline.mjs';
import { reversed22y3au42jl32b as reversed } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  SetupRequest_instance2zzqkp8zxmw91 as SetupRequest_instance,
  Send_instance1oebf6ttzyqzk as Send_instance,
} from './api/CommonHooks.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { unwrapCancellationException1zvbmufui4i9c as unwrapCancellationException } from '../utils/ExceptionUtils.nonJvm.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { OutgoingContent3t2ohmyam9o76 as OutgoingContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  get_coroutineContext1djaai1ellg0c as get_coroutineContext,
  HttpRequest3fsc4149kgwfg as HttpRequest,
} from '../request/HttpRequest.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return LOGGER;
}
var LOGGER;
function get_HttpCallValidator() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return HttpCallValidator;
}
var HttpCallValidator;
function get_ExpectSuccessAttributeKey() {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return ExpectSuccessAttributeKey;
}
var ExpectSuccessAttributeKey;
var HttpCallValidatorConfigClass;
function HttpCallValidatorConfig() {
  if (HttpCallValidatorConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.n5q_1 = ArrayList().p2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp_0.o5q_1 = ArrayList().p2();
        this.p5q_1 = true;
      }
      q5q(block) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.n5q_1.j2(block);
      }
    }
    initMetadataForClass($, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
    HttpCallValidatorConfigClass = $;
  }
  return HttpCallValidatorConfigClass;
}
function HttpResponseValidator(_this__u8e3s4, block) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  _this__u8e3s4.q5l(get_HttpCallValidator(), block);
}
var ExceptionHandlerWrapperClass;
function ExceptionHandlerWrapper() {
  if (ExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ExceptionHandlerWrapper');
    ExceptionHandlerWrapperClass = $;
  }
  return ExceptionHandlerWrapperClass;
}
var RequestExceptionHandlerWrapperClass;
function RequestExceptionHandlerWrapper() {
  if (RequestExceptionHandlerWrapperClass === VOID) {
    class $ {}
    initMetadataForClass($, 'RequestExceptionHandlerWrapper');
    RequestExceptionHandlerWrapperClass = $;
  }
  return RequestExceptionHandlerWrapperClass;
}
function RequestError$install$slambda($handler) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    try {
      yield* $this$intercept.z4u($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $($handler(HttpRequest_0($this$intercept.w4v_1), cause, $completion), $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 2);
}
var RequestErrorClass;
function RequestError() {
  if (RequestErrorClass === VOID) {
    class $ {
      d5s(client, handler) {
        var tmp = Phases_getInstance().p5p_1;
        client.n5j_1.a4w(tmp, RequestError$install$slambda(handler));
      }
      u5p(client, handler) {
        return this.d5s(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RequestError');
    RequestErrorClass = $;
  }
  return RequestErrorClass;
}
var RequestError_instance;
function RequestError_getInstance() {
  return RequestError_instance;
}
function ReceiveError$install$slambda($handler) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    try {
      yield* $this$intercept.z4u($completion);
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        var error = yield* $($handler($this$intercept.w4v_1.y5l(), cause, $completion), $completion);
        if (!(error == null))
          throw error;
      } else {
        throw $p;
      }
    }
    return Unit_instance;
  }), 2);
}
var ReceiveErrorClass;
function ReceiveError() {
  if (ReceiveErrorClass === VOID) {
    class $ {
      d5s(client, handler) {
        var BeforeReceive = new (PipelinePhase())('BeforeReceive');
        client.o5j_1.z4v(Phases_getInstance_0().v5k_1, BeforeReceive);
        client.o5j_1.a4w(BeforeReceive, ReceiveError$install$slambda(handler));
      }
      u5p(client, handler) {
        return this.d5s(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ReceiveError');
    ReceiveErrorClass = $;
  }
  return ReceiveErrorClass;
}
var ReceiveError_instance;
function ReceiveError_getInstance() {
  return ReceiveError_instance;
}
function HttpRequest_0(builder) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  return new (HttpRequest$1())(builder);
}
function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
  return constructCallableReference(() => new (HttpCallValidatorConfig())(), 0, 0, 218, '<init>');
}
function HttpCallValidator$lambda($this$createClientPlugin) {
  _init_properties_HttpCallValidator_kt__r6yh2y();
  var responseValidators = reversed($this$createClientPlugin.b5q_1.n5q_1);
  var callExceptionHandlers = reversed($this$createClientPlugin.b5q_1.o5q_1);
  var expectSuccess = $this$createClientPlugin.b5q_1.p5q_1;
  var tmp = SetupRequest_instance;
  $this$createClientPlugin.e5q(tmp, HttpCallValidator$lambda$slambda(expectSuccess));
  var tmp_0 = Send_instance;
  $this$createClientPlugin.e5q(tmp_0, HttpCallValidator$lambda$slambda_0(responseValidators));
  var tmp_1 = RequestError_instance;
  $this$createClientPlugin.e5q(tmp_1, HttpCallValidator$lambda$slambda_1(callExceptionHandlers));
  var tmp_2 = ReceiveError_instance;
  $this$createClientPlugin.e5q(tmp_2, HttpCallValidator$lambda$slambda_2(callExceptionHandlers));
  return Unit_instance;
}
function *invoke$validateResponse(responseValidators, response, $completion) {
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Validating response for request ' + response.f5m().y5l().h5m().toString();
    this_0.b4x(tmp$ret$1);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = responseValidators.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    yield* $(element(response, $completion), $completion);
  }
  return Unit_instance;
}
function *invoke$processException(callExceptionHandlers, cause, request, $completion) {
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Processing exception ' + toString(getKClassFromExpression(cause)) + ' for request ' + request.h5m().toString();
    this_0.c4x(tmp$ret$1, cause);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = callExceptionHandlers.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (element instanceof ExceptionHandlerWrapper())
      yield* $(element.f5s_1(cause, $completion), $completion);
    else {
      if (element instanceof RequestExceptionHandlerWrapper())
        yield* $(element.e5s_1(cause, request, $completion), $completion);
      else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function HttpCallValidator$lambda$slambda($expectSuccess) {
  return constructCallableReference((request, $completion) => orPromise($completion, function *($completion) {
    var tmp = get_ExpectSuccessAttributeKey();
    request.m5l_1.o4q(tmp, () => $expectSuccess);
    return Unit_instance;
  }), 1);
}
function HttpCallValidator$lambda$slambda_0($responseValidators) {
  return constructCallableReference(($this$on, request, $completion) => orPromise($completion, function *($completion) {
    var call = yield* $this$on.i5s(request, $completion);
    yield* /*#__NOINLINE__*/invoke$validateResponse($responseValidators, call.a5k(), $completion);
    return call;
  }), 2);
}
function HttpCallValidator$lambda$slambda_1($callExceptionHandlers) {
  return constructCallableReference((request, cause, $completion) => orPromise($completion, function *($completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }), 2);
}
function HttpCallValidator$lambda$slambda_2($callExceptionHandlers) {
  return constructCallableReference((request, cause, $completion) => orPromise($completion, function *($completion) {
    var unwrappedCause = unwrapCancellationException(cause);
    yield* /*#__NOINLINE__*/invoke$processException($callExceptionHandlers, unwrappedCause, request, $completion);
    return unwrappedCause;
  }), 2);
}
var HttpRequest$1Class;
function HttpRequest$1() {
  if (HttpRequest$1Class === VOID) {
    class $ {
      constructor($builder) {
        this.n5s_1 = $builder;
        this.j5s_1 = $builder.i5l_1;
        this.k5s_1 = $builder.h5l_1.e3a();
        this.l5s_1 = $builder.m5l_1;
        this.m5s_1 = $builder.j5l_1.e3a();
      }
      f5m() {
        // Inline function 'kotlin.error' call
        var message = 'Call is not initialized';
        throw IllegalStateException().o(toString(message));
      }
      g5m() {
        return this.j5s_1;
      }
      h5m() {
        return this.k5s_1;
      }
      z5l() {
        return this.l5s_1;
      }
      e55() {
        return this.m5s_1;
      }
      y2q() {
        var tmp = this.n5s_1.k5l_1;
        var tmp0_elvis_lhs = tmp instanceof OutgoingContent() ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString(this.n5s_1.k5l_1);
          throw IllegalStateException().o(toString(message));
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return tmp_0;
      }
    }
    protoOf($).ww = get_coroutineContext;
    initMetadataForClass($, VOID, VOID, VOID, [HttpRequest()]);
    HttpRequest$1Class = $;
  }
  return HttpRequest$1Class;
}
var properties_initialized_HttpCallValidator_kt_xrx49w;
function _init_properties_HttpCallValidator_kt__r6yh2y() {
  if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
    properties_initialized_HttpCallValidator_kt_xrx49w = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
    var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
    HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ExpectSuccessAttributeKey';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().yf();
    var tmp_1 = !(null == null) ? typeof null === 'boolean' : false;
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_2;
    try {
      tmp_2 = createKType(PrimitiveClasses_getInstance().yf(), arrayOf([]), false);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_3 = null;
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    var tmp$ret$2 = tmp_2;
    var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp_1, tmp$ret$2);
    ExpectSuccessAttributeKey = new (AttributeKey())(name, tmp$ret$1);
  }
}
//region block: init
RequestError_instance = new (RequestError())();
ReceiveError_instance = new (ReceiveError())();
//endregion
//region block: exports
export {
  get_ExpectSuccessAttributeKey as get_ExpectSuccessAttributeKey20jj5fup38v1g,
  get_HttpCallValidator as get_HttpCallValidator3iji36qylbtbr,
  HttpResponseValidator as HttpResponseValidator2d6ie1tmzg8fi,
};
//endregion

//# sourceMappingURL=HttpCallValidator.mjs.map
